import React from "react";
import MProgressBar from "../MProgressBar/MProgressBar";

import "./MColapsedPlayer.css";
import usePlayerUtils from "../../hooks/usePlayerUtils";
import { useAudioVisualizer } from "../../hooks/useAudioVisualizer";

function MColapsedPlayer({ wrapChildClick, togglePlay, onTabChevron, collapsedOpacity }) {
        const {
            audioRef,
            currentTrack,
            detachHls,
            setPlaybackState,
            playbackState,
            setCurrentTimeSec,
            progressBarPercent,
            durationPercent,
            setTimeShiftOffsetSec,
        } = usePlayerUtils();

    const artist = currentTrack?.artist;
    const songTitle = currentTrack?.title;

    const canvasRef = useAudioVisualizer(audioRef);

    const stopPlayback = () => {
        const audio = audioRef.current;
        if (!audio) return;

        audio.pause();
        detachHls();
        setPlaybackState("stopped");
        setCurrentTimeSec(0);
        setTimeShiftOffsetSec(0);
    };

    const stopBtnClassName = playbackState === "stopped" ? "m-btn-disabled m-stop-btn" : "m-stop-btn";

    return (
        <div className="player-collapsed" style={{ opacity: collapsedOpacity }} >
            <div className="chevron-up"><button onClick={onTabChevron} className="chevron-btn"><i className="fa-solid fa-chevron-up"></i></button></div>
            <div className="colapsed-content">
                <canvas
                    ref={canvasRef}
                    width={360}
                    height={80}
                    className="colapsed-analyzer"
                />
                <div className="main-colapsed-player">
                    <div className="colapsed-player-btn">
                        <div className="progress-ring" style={{ "--percent": `${durationPercent() * 100}%` }}>
                            <button className="m-play-btn" onClick={wrapChildClick(() => togglePlay())}>
                                {playbackState === "playing"
                                    ? <i className="fas fa-pause"></i>
                                    : <i className="fas fa-play"></i>
                                }
                            </button>
                        </div>
                    </div>
                    <div className="colapsed-song-info">
                        <div className="m-song-info">
                            <div className="song-title">{songTitle}</div>
                            <div className="artist">{artist}</div>
                        </div>
                        <div className="colapsed-progress-bar">
                            <MProgressBar progressPercent={progressBarPercent / 100} seekable={false} />
                        </div>
                    </div>
                    <div className="colapsed-player-btn">
                        <div className="sopt-btn-ring" style={{ "--percent": "100%" }}>
                            <button className={stopBtnClassName} onClick={wrapChildClick(() => stopPlayback())} disabled={playbackState === "stopped"}>
                                <i className="fas fa-stop"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default React.memo(MColapsedPlayer);